export const zetProFixedList = [
  '2006011',
  '943375',
  '2089821',
  '2091946',
  '2144323',
  '2078298',
  '2058366',
  '2154557',
  '2147664',
  '2117369',
  '2156200',
  '2162262',
  '2163794',
  '2163772',
  '2165999',
  '2078113',
]

export const zetProList = [
  '2156200',
  '2143963',
  '2071096',
  '2074012',
  '2078298',
  '2154557',
  '1939969',
  '139485',
  '2170353',
  '2162262',
  '2117369',
  '2165999',
  '2063310',
  '2084263',
  '2163794',
  '1695075',
  '2087480',
  '1982934',
  '2168178',
  '2080164',
  '2151208',
  '2128389',
  '2087490',
  '2089821',
  '2061033',
  '2161879',
  '2144323',
  '2063308',
  '2006011',
  '2078113',
  '289820',
  '2087438',
  '2085637',
  '1995631',
  '2163772',
  '1904363',
  '2168805',
  '2155838',
  '2154567',
  '2091946',
  '2115409',
  '2147664',
  '2058366',
  '943375',
  '2057584',
  '1467552', // staging
]
